
import {waitForPageTransition} from '~/services/helpers'
import getAllBlogs from '~/queries/blogs.gql'
import thumbnailFallback from '~/assets/imgs/thumbnail-fallback.jpg'
import Visual from 'vue-visual'
import FeaturedCard from './featured-card';
import SimpleCard from '~/components/blocks/simple-cards/card'
import HeightTween from 'vue-height-tween-transition'
import ClickOutside from 'vue-click-outside'
import Close from './close'

export default
	props: block: Object

	components: { Visual, FeaturedCard, SimpleCard, HeightTween, Close }

	directives: { ClickOutside }

	data: ->
		allBlogs: []
		allCategories: []
		allTags: []
		showMobileCategories: false
		showMobileSearch: false
		selectedCategory: null
		sort: undefined
		search: ''
		activeSearch: ''
		resultsCount: 8

	computed:
		classes: -> [
			kebabCase @marqueeTextColor || 'white', 'marquee-text-color'
		]

		styles: ->
			'--marquee-text-color': @marqueeTextColor

		marqueeTextColor: -> @block.marqueeTextColor || 'white'

		imageClasses: -> [
			"overlay-intensity-#{@block.overlayIntensity || 'low'}" if @block.overlayIntensity != "no-overlay"
			"overlay-type-#{@block.overlayType || 'solid'}" if @block.overlayIntensity != "no-overlay"
		]

	 	# Categories that have at least one blog associated with them
		computedCategories: ->
			@allCategories.filter (category) =>
				@allBlogs.some (blog) =>
					blog.blogCategories?.some (cat) =>
						cat.title == category.title

		sortOptions: -> [
			{ label: 'Newest', value: 'newest' }
			{ label: 'Oldest', value: 'oldest'}
			{ label: 'A-Z', value: 'a-z' }
			{ label: 'Z-A', value: 'z-a' }
		]

		resultsHeading: ->
			if !@selectedCategory then category = 'All Posts'
			else category = switch @selectedCategory
				when 'Article' then 'Articles'
				when 'Podcast' then 'Podcasts'
				when 'Video' then 'Videos'
				when 'Press' then 'Press'
				else @selectedCategory

			if !@search then return category
			else return "Results for '#{@search}'"

		isCraftHighlight: -> @highlightMedia != thumbnailFallback

		highlightBlog: -> @block.highlightBlog?[0]

		highlightMedia: ->
			if @highlightBlog.thumbnail?.length then return @highlightBlog.thumbnail[0]
			if @highlightBlog.highlightMedia?.length then return @highlightBlog.highlightMedia[0]
			return thumbnailFallback

		highlightCategory: -> @highlightBlog.blogCategories?[0]?.title

		highlightDate: ->
			date = new Date @highlightBlog.dateCreated
			date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

		highlightAuthor: -> @highlightBlog.author

		highlightTitle: -> @highlightBlog.title

		thumbnailFallback: -> thumbnailFallback

		highlightUrl: -> "/blogs/#{@highlightBlog.slug}"

		highlightThumbnailLegend: ->
			return unless @highlightBlog.thumbnail?.length
			@highlightBlog.thumbnailLegend

		featuredBlogs: -> if @block.featuredBlogs.length then @block.featuredBlogs else @allBlogs.slice(0, 3)

		# TBH: this should be a computed property
		highlightReadTime: -> '5 min read'

		computedBlogsToList: -> @blogsToList.slice(0, @resultsCount)

		blogsToList: ->
			result = @allBlogs.filter (blog) =>
				if @selectedCategory
					blog.blogCategories?.some (category) =>
						category.title == @selectedCategory
				else true

			result = result.filter (blog) =>
				if @search
					blog.title.toLowerCase().includes(@search.toLowerCase().trim()) || blog.tags?.some (tag) =>
						tag?.title?.toLowerCase()?.includes(@search.toLowerCase().trim())
				else true

			if !@sort then return result

			switch @sort
				when 'newest' then result.sort (a, b) -> new Date(b.dateCreated) - new Date(a.dateCreated)
				when 'oldest' then result.sort (a, b) -> new Date(a.dateCreated) - new Date(b.dateCreated)
				when 'a-z' then result.sort (a, b) -> a.headline.localeCompare(b.headline)
				when 'z-a' then result.sort (a, b) -> b.headline.localeCompare(a.headline)

	watch: search: (newVal) ->
		url = new URL window.location.href

		if newVal
			url.searchParams.set 'search', newVal
		else
			url.searchParams.delete 'search'

		history.pushState null, '', url.toString()
		@resultsCount = 8

	beforeMount: ->
		if @$route.query.search
			@search = @$route.query.search

	fetch: ->
		{@allBlogs, @allCategories, @allTags} = await @$craft.execute
			query: getAllBlogs

	methods:
		showMore: -> @resultsCount += 8

		clearSearch: ->
			@search = ''
			@resultsCount = 8

		clickOutsideSearch: ->
			@showMobileSearch = false

		getBlogThumbnail: (blog) ->
			if blog.thumbnail?.length then return blog.thumbnail[0]
			if blog.highlightMedia?.length then return blog.highlightMedia[0]
			return thumbnailFallback

		toggleMobileCategories: ->
			@showMobileCategories = !@showMobileCategories

		toggleMobileSearch: ->
			@showMobileSearch = !@showMobileSearch

		selectCategory: (category) ->
			if !category then @selectedCategory = null
			else if @selectedCategory == category then @selectedCategory = null
			else @selectedCategory = category

		selectCategoryMobile: (category) ->
			@selectCategory(category)
			@showMobileCategories = false

		formatDate: (date) ->
			date = new Date(date)
			mm = String(date.getMonth() + 1).padStart(2, '0')
			dd = String(date.getDate()).padStart(2, '0')
			yyyy = date.getFullYear()

			return "#{mm}.#{dd}.#{yyyy}";


